export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, shrink-to-fit=no"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image/png","href":"/favicon.png"}],"style":[],"script":[{"innerHTML":"function validateBrowser(){if(!(window.location.pathname.indexOf(\"/unsupported-browser\")>=0)){var r=/Edge?\\/([80]\\d|\\d{3,})\\.\\d+(\\.\\d+|)|Firefox\\/(7[89]|[8-9]\\d|\\d{3,})\\.\\d+(\\.\\d+|)|Chrom(ium|e)\\/([80]\\d|\\d{3,})\\.\\d+(\\.\\d+|)|(Maci|X1{2}).+ Version\\/(1[4-9]|[2-9]\\d|\\d{3,})\\.\\d+([,.]\\d+|)( \\(\\w+\\)|)( Mobile\\/\\w+|) Safari\\/|Chrome.+OPR\\/(6[7-9]|[7-9]\\d|\\d{3,})\\.\\d+\\.\\d+|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(14[._]\\d+|(1[5-9]|[2-9]\\d|\\d{3,})[._]\\d+)([._]\\d+|)|Android.+Firefox\\/(13\\d|1[4-9]\\d|[2-9]\\d{2}|\\d{4,})\\.\\d+(\\.\\d+|)|Android.+Chrom(ium|e)\\/(13\\d|1[4-9]\\d|[2-9]\\d{2}|\\d{4,})\\.\\d+(\\.\\d+|)|SamsungBrowser\\/(1[2-9]|[2-9]\\d|\\d{3,})\\.\\d+/,e=\"\";if(window.navigator&&window.navigator.userAgent&&(e=window.navigator.userAgent),!r.test(e)){var d=window.location.pathname.split(\"/\").filter(function(o){return o.length})[0];d&&d.length===2?d=\"/\"+d:d=\"\",window.location.href=d+\"/unsupported-browser\"}}}validateBrowser();","tagPosition":"head","tagPriority":"critical"}],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1, maximum-scale=1, shrink-to-fit=no","title":"Alphabet","bodyAttrs":{"class":"font-sans theme-alphabet","data-theme":"alphabet"}}

export const appPageTransition = false

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true